module.exports = __webpack_public_path__ + "img/levante-logo-icon.bba49705.png";